import {PlanInfo, PlanList} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Confirm} from '@wix/wix-ui-icons-common'
import {Tag} from '@wix/wix-ui-icons-common/on-stage'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Dropdown, DropdownOptionProps, DropdownOptionTextOverflow} from 'wix-ui-tpa/cssVars'
import {getPlanBenefitText, planHasRemainingCredits} from '../../../selectors/paid-plans'
import c from '../../classnames.scss'
import {NO_MEMBERSHIP_PLAN_ORDER_ID} from '../../form/constants'
import fs from '../../form/form.scss'
import {MembershipSelectorProps} from './interfaces'
import s from './membership-selector.scss'
import {classes} from './membership-selector.st.css'

export const MembershipSelector = ({
  shouldShow,
  orderCompleted,
  selectedPlan,
  eventId,
  reservationId,
  applyPlan,
  purchasedPlans,
}: MembershipSelectorProps) => {
  const {t} = useTranslation()

  const getPlanOptions = (): PlanList => [
    {
      id: undefined,
      name: t('membership_not_selected'),
      status: undefined,
      visible: true,
      purchased: true,
      discount: undefined,
      remainingCredits: undefined,
      planOrderId: NO_MEMBERSHIP_PLAN_ORDER_ID,
      benefitId: undefined,
      plan: {},
    },
    ...purchasedPlans,
  ]

  const setSelectedPlan = (planOrderId: string) => applyPlan({eventId, reservationId, planOrderId})

  const planOptions = getPlanOptions()

  if (!shouldShow || (orderCompleted && !selectedPlan)) {
    return null
  }

  const dropdownOptions: DropdownOptionProps[] = planOptions.map((plan: PlanInfo) => ({
    id: plan.planOrderId,
    value: plan.name,
    subtitle: plan.planOrderId === NO_MEMBERSHIP_PLAN_ORDER_ID ? undefined : getPlanBenefitText(plan, t, true),
    isSelectable: planHasRemainingCredits(plan) || plan.planOrderId === NO_MEMBERSHIP_PLAN_ORDER_ID,
    disabled: !planHasRemainingCredits(plan),
    icon: <Tag />,
    textOverflow: DropdownOptionTextOverflow.wrap,
  }))

  return (
    <div className={fs.summaryBlock}>
      {orderCompleted ? (
        <div className={classNames(s.inputContainer, c.formSummaryBox)}>
          <Confirm className={s.icon} size="24px" />
          <div className={classNames(s.text, s.selectedText, c.formSummaryBody, c.formSummaryColor)}>
            {selectedPlan ? selectedPlan?.name : t('membership_not_selected')}
          </div>
        </div>
      ) : (
        <Dropdown
          data-hook={DH.MEMBERSHIP_SELECTOR}
          disabled={orderCompleted}
          options={dropdownOptions}
          initialSelectedId={selectedPlan?.planOrderId ?? NO_MEMBERSHIP_PLAN_ORDER_ID}
          className={classes.root}
          upgrade
          onChange={selectedOption => setSelectedPlan(selectedOption.id)}
          mobileNativeSelect
        />
      )}
    </div>
  )
}
